<template>
<v-layout align-center justify-center row fill-height>
    <v-card>
        <v-card-title>
            <span>You are not authorized to access that page.</span>
        </v-card-title>
    </v-card>
</v-layout>
</template>

<script>
import auth from '@/services/auth';

export default {
    components: {

    },
    data() {
        return {
            show: true
        };
    }
};
</script>